exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-div[data-v-86fa05fc]{width:94%;margin-left:23px}.modal-container[data-v-86fa05fc]{height:100%}@media screen and (max-width:576px){.popup-div[data-v-86fa05fc]{height:200px;width:300px;margin-top:3rem}.align-return-btn[data-v-86fa05fc]{margin-top:-70px;margin-left:30px}}@media screen and (min-width:577px){.align-return-btn[data-v-86fa05fc]{margin-left:30px;margin-top:100px}}", ""]);

// exports
